

export interface OedsPerson {
  oedsPersonKey: string
  emailList: EmailList[]
  phoneList: PhoneList[]
  addressList: AddressList[]
  orgEmailList: OrgEmailList[]
}

export interface EmailList {
  actionType: string
  oedsEmailKey: number
  email: string
  oedsEmailType: number
  primaryFlag: boolean
  privateFlag: boolean
  isMapped?: boolean;
  exEmail:string
}

export interface PhoneList {
  actionType: string
  oedsPhoneKey: number
  areaCode: string
  phoneNumber: string
  phoneNumberDisplay: string;
  oedsPhoneType: number
  primaryFlag: boolean;
  privateFlag: boolean;
  isConfirm: boolean;
}
export interface State {
  key: number;
  name: string;
  abbreviation: string;
}

export interface AddressList {
  actionType: string
  oedsAddressKey: number
  addressI: string
  mailStop: any
  city: string
  stateKey: number
  state: string
  county: string
  zipCode: string
  zipCode4: string
  oedsAddressType: number
  oedsLocationType: number
  isConfirm: boolean
}

export interface OrgEmailList {
  actionType: string
  oedsOrgKey: number
  orgKey: number;
  orgIrnNo: string
  orgName:string
  oedsEmailKey:number
  email: string
}
export enum oedsEmailTypeKeys {
  Home = 2,
  Office=3
}

export enum oedsAddressTypeKeys {
  Physical = 1,
  Mailing = 3
}
export enum oedsLocationTypeKeys {
  Home = 3,
  Office = 4
}
export enum oedsPhoneTypeKeys {
  Office = 1,
  Home = 2,
  Cell = 3,
  Mobile=3
}
export interface OrgCollection{
  orgId: number,
  orgIrnNo: string,
  orgName: string,
  emailId: number;
  email:string
}

